import type { ReactNode } from 'react';

import type { TImageElement } from '@shared/dream-components';
import { ImageElement } from '@shared/dream-components';

import usePodcastMergeTagProcessor from './hooks/usePodcastMergeTagProcessor';
import useProductMergeTagProcessor from './hooks/useProductMergeTagProcessor';

interface Props {
  node: TImageElement;
  children: ReactNode | ReactNode[];
}

const Image = ({ node, children }: Props) => {
  const { node: nodeToRenderPodcast } = usePodcastMergeTagProcessor({
    node,
    children,
  });
  const { node: nodeToRender } = useProductMergeTagProcessor({
    node: nodeToRenderPodcast,
    children,
  });

  return <ImageElement element={nodeToRender}>{children}</ImageElement>;
};

export default Image;
